import React from 'react'


function Menu(props) {

  return (
    <div >

      <a href='/RoomActivity' className='menu_links'>
        <div className={(props.id === "RoomActivity") ? "menu_div_selected" : "menu_div"}>
          <i className="bi bi-file-earmark-spreadsheet" style={{ paddingRight: "5px" }}></i>
          Room Activity
        </div>
      </a>

      <a href='/StationReport' className='menu_links'>
        <div className={(props.id === "StationReport") ? "menu_div_selected" : "menu_div"}>
          <i className="bi bi-file-earmark-spreadsheet" style={{ paddingRight: "5px" }}></i>
          Station Report
        </div>
      </a>

      <a href='/SmsContacts' className='menu_links'>
        <div className={(props.id === "SmsContacts") ? "menu_div_selected" : "menu_div"}>
          <i className="bi bi-phone-vibrate" style={{ paddingRight: "5px" }}></i>
          SMS Contacts
        </div>
      </a>

      <a href='/ErrorActivityLog' className='menu_links'>
        <div className={(props.id === "ErrorActivityLog") ? "menu_div_selected" : "menu_div"}>
          <i className="bi bi-exclamation-triangle" style={{ paddingRight: "5px" }}></i>
          Error Activity Log
        </div>
      </a>

      <a href='/AssignRoom' className='menu_links'>
        <div className={(props.id === "AssignRoom") ? "menu_div_selected" : "menu_div"}>
          <i className="bi bi-door-open" style={{ paddingRight: "5px" }}></i>
          Assign Room
        </div>
      </a>

      <a href='/Rooms' className='menu_links'>
        <div className={(props.id === "Rooms") ? "menu_div_selected" : "menu_div"}>
          <i className="bi bi-door-closed" style={{ paddingRight: "5px" }}></i>
          Rooms
        </div>
      </a>

      <a href='/Settings' className='menu_links'>
        <div className={(props.id === "Settings") ? "menu_div_selected" : "menu_div"}>
          <i className="bi bi-gear" style={{ paddingRight: "5px" }}></i>
          Settings
        </div>
      </a>

      <a href='/Logout' className='menu_links'>
        <div className={(props.id === "Logout") ? "menu_div_selected" : "menu_div"}>
          <i className="bi bi-box-arrow-left" style={{ paddingRight: "5px" }}></i>
          Logout
        </div>
      </a>



    </div>

  )
}

export default Menu